export default class {

    constructor(report = true) {
        this.report = report;
    }

    log(message) {
        if (!this.report) {
            return;
        }
        console.log(message);
    }

}